import React from 'react';

const Confirm = (props) => {
    return <div></div>;
};

export default Confirm;
